import React, { useEffect, useRef, useState } from "react"

import { useDispatch, useSelector } from "react-redux"
import { fetchAlgs } from "../../actions/internalActions"
import { FILTER_TYPE } from "../../util/filters/filterConstants"
import { FilterManager } from "../../util/filters/filterManager"
import CustomTableContainer from "../Common/Table/CustomTableContainer"
import UpdateAlgConfigModal from "./modals/updateAlgConfig"

export default function AlgMetadata() {
  const [processedAlgs, setProcessedAlgs] = useState([])
  const algsData = useSelector((state) => state.internal.algs)
  const [modalData, setModalData] = useState({ open: false })
  const dispatch = useDispatch()

  const filterManagerRef = useRef(null)
  if (!filterManagerRef.current) {
    filterManagerRef.current = FilterManager.Builder.addFilter(FILTER_TYPE.ALG_META.ID, true)
      .addFilter(FILTER_TYPE.ALG_META.NAME, true)
      .addFilter(FILTER_TYPE.ALG_META.FRAMEWORK, true)
      .addFilter(FILTER_TYPE.ALG_META.DATE_CREATED, true)
      .addFilter(FILTER_TYPE.ALG_META.BUCKET, true)
      .addFilter(FILTER_TYPE.ALG_META.PATH, true)
      .addFilter(FILTER_TYPE.ALG_META.CHECKSUM, true)
      .build()
  }
  const filterManager = filterManagerRef.current

  const handleClick = (_, row) => {
    const newModalData = {
      open: true,
      algId: row.meta_alg_id,
      bucket: row.meta_alg_bucket,
      path: row.meta_alg_path,
    }
    setModalData(newModalData)
  }

  const handleClose = () => {
    setModalData({ open: false })
    dispatch(fetchAlgs())
  }

  useEffect(() => {
    if (algsData) {
      setProcessedAlgs(
        algsData.map((alg, index) => {
          return {
            ...filterManager.generateDataMap(
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              alg,
            ),
            id: index,
          }
        }),
      )
    }
  }, [algsData, filterManager.generateDataMap])

  return (
    <>
      <CustomTableContainer
        defaultOrder="desc"
        defaultOrderHeader={FILTER_TYPE.ALG_META.ID}
        headers={filterManager.getHeaders()}
        filterManager={filterManager}
        rowData={processedAlgs}
        paginationOptions={[5, 10, 25, 50, 100]}
        defaultPaginationOption={25}
        clickAction={handleClick}
      />
      {modalData?.algId && (
        <UpdateAlgConfigModal
          algId={modalData.algId}
          bucket={modalData.bucket}
          path={modalData.path}
          open={modalData.open}
          handleClose={handleClose}
        />
      )}
    </>
  )
}
